import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { generalFlowDataKey, GeneralFlowDataState, generalReducer } from '@store/flow-data/general';
import { localStorageSync } from 'ngrx-store-localstorage';
import { initFlowFlowDataKey, initFlowReducer } from './flow-data/init-flow';
import { quoteFlowDataKey, quoteReducer
 } from './flow-data/quote';

// tslint:disable-next-line: no-any
const reducers: ActionReducerMap<any> = {
  [generalFlowDataKey]: generalReducer,
  [initFlowFlowDataKey]: initFlowReducer,
  [quoteFlowDataKey]: quoteReducer,
};

// Meta-reducer to sync with localStorage
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    storage: sessionStorage,
    keys: [generalFlowDataKey, initFlowFlowDataKey, quoteFlowDataKey],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

export interface AppState {
  [generalFlowDataKey]: GeneralFlowDataState;
}

export { reducers };
